"use strict";
/*
 * Copyright 2016, Google Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *     * Redistributions of source code must retain the above copyright
 * notice, this list of conditions and the following disclaimer.
 *     * Redistributions in binary form must reproduce the above
 * copyright notice, this list of conditions and the following disclaimer
 * in the documentation and/or other materials provided with the
 * distribution.
 *     * Neither the name of Google Inc. nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */

var _regeneratorRuntime = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _createClass = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _classCallCheck = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\new_kisan\\kisan_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var grpcProtoLoaderTypes = require("@grpc/proto-loader"); // for types only


var fs = require("fs");

var google_auth_library_1 = require("google-auth-library");

var google_proto_files_1 = require("google-proto-files");

var grpcTypes = require("grpc"); // for types only


var path = require("path");

var protobuf = require("protobufjs");

var semver = require("semver");

var walk = require("walkdir");

var gax = require("./gax");

var googleProtoFilesDir = path.normalize(google_proto_files_1.getProtoPath('..')); // INCLUDE_DIRS is passed to @grpc/proto-loader

var INCLUDE_DIRS = [];
INCLUDE_DIRS.push(googleProtoFilesDir); // COMMON_PROTO_FILES logic is here for protobufjs loads (see
// GoogleProtoFilesRoot below)

var COMMON_PROTO_DIRS = [// This list of directories is defined here:
// https://github.com/googleapis/googleapis/blob/master/gapic/packaging/common_protos.yaml
'api', path.join('iam', 'v1'), path.join('logging', 'type'), 'longrunning', 'protobuf', 'rpc', 'type'].map(function (dir) {
  return path.join(googleProtoFilesDir, 'google', dir);
});
var COMMON_PROTO_FILES = COMMON_PROTO_DIRS.map(function (dir) {
  return walk.sync(dir).filter(function (f) {
    return path.extname(f) === '.proto';
  }).map(function (f) {
    return path.normalize(f).substring(googleProtoFilesDir.length + 1);
  });
}).reduce(function (a, c) {
  return a.concat(c);
}, []);

var ClientStub =
/*#__PURE__*/
function (_grpcTypes$Client) {
  _inherits(ClientStub, _grpcTypes$Client);

  function ClientStub() {
    _classCallCheck(this, ClientStub);

    return _possibleConstructorReturn(this, _getPrototypeOf(ClientStub).apply(this, arguments));
  }

  return ClientStub;
}(grpcTypes.Client);

exports.ClientStub = ClientStub;

var GrpcClient =
/*#__PURE__*/
function () {
  /**
   * A class which keeps the context of gRPC and auth for the gRPC.
   *
   * @param {Object=} options - The optional parameters. It will be directly
   *   passed to google-auth-library library, so parameters like keyFile or
   *   credentials will be valid.
   * @param {Object=} options.auth - An instance of google-auth-library.
   *   When specified, this auth instance will be used instead of creating
   *   a new one.
   * @param {Object=} options.grpc - When specified, this will be used
   *   for the 'grpc' module in this context. By default, it will load the grpc
   *   module in the standard way.
   * @param {Function=} options.promise - A constructor for a promise that
   * implements the ES6 specification of promise. If not provided, native
   * promises will be used.
   * @constructor
   */
  function GrpcClient() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, GrpcClient);

    this.auth = options.auth || new google_auth_library_1.GoogleAuth(options);
    this.promise = options.promise || Promise;

    if ('grpc' in options) {
      this.grpc = options.grpc;
      this.grpcVersion = '';
    } else {
      // EXPERIMENTAL: If GOOGLE_CLOUD_USE_GRPC_JS is set, use the JS-based
      // implementation of the gRPC client instead. Requires http2 (Node 8+).
      if (semver.satisfies(process.version, '8.x') && process.env.GOOGLE_CLOUD_USE_GRPC_JS) {
        this.grpc = require('@grpc/grpc-js');
        this.grpcVersion = require('@grpc/grpc-js/package.json').version;
      } else {
        this.grpc = require('grpc');
        this.grpcVersion = require('grpc/package.json').version;
      }
    }

    this.grpcProtoLoader = require('@grpc/proto-loader');
  }
  /**
   * Creates a gRPC credentials. It asks the auth data if necessary.
   * @private
   * @param {Object} opts - options values for configuring credentials.
   * @param {Object=} opts.sslCreds - when specified, this is used instead
   *   of default channel credentials.
   * @return {Promise} The promise which will be resolved to the gRPC credential.
   */


  _createClass(GrpcClient, [{
    key: "_getCredentials",
    value: function _getCredentials(opts) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var grpc, sslCreds, client, credentials;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!opts.sslCreds) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", opts.sslCreds);

              case 2:
                grpc = this.grpc;
                sslCreds = grpc.credentials.createSsl();
                _context.next = 6;
                return this.auth.getClient();

              case 6:
                client = _context.sent;
                credentials = grpc.credentials.combineChannelCredentials(sslCreds, grpc.credentials.createFromGoogleCredential(client));
                return _context.abrupt("return", credentials);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Loads the gRPC service from the proto file at the given path and with the
     * given options.
     * @param filename The path to the proto file.
     * @param options Options for loading the proto file.
     */

  }, {
    key: "loadFromProto",
    value: function loadFromProto(filename, options) {
      var packageDef = grpcProtoLoaderTypes.loadSync(filename, options);
      return this.grpc.loadPackageDefinition(packageDef);
    }
    /**
     * Load grpc proto service from a filename hooking in googleapis common protos
     * when necessary.
     * @param {String} protoPath - The directory to search for the protofile.
     * @param {String} filename - The filename of the proto to be loaded.
     * @return {Object<string, *>} The gRPC loaded result (the toplevel namespace
     *   object).
     */

  }, {
    key: "loadProto",
    value: function loadProto(protoPath, filename) {
      var resolvedPath = GrpcClient._resolveFile(protoPath, filename);

      var retval = this.grpc.loadObject(protobuf.loadSync(resolvedPath, new GoogleProtoFilesRoot()));
      return retval;
    }
  }, {
    key: "metadataBuilder",
    value: function metadataBuilder(headers) {
      var Metadata = this.grpc.Metadata;
      var baseMetadata = new Metadata(); // tslint:disable-next-line forin

      var _loop = function _loop(key) {
        var value = headers[key];

        if (Array.isArray(value)) {
          value.forEach(function (v) {
            return baseMetadata.add(key, v);
          });
        } else {
          baseMetadata.set(key, "".concat(value));
        }
      };

      for (var key in headers) {
        _loop(key);
      }

      return function buildMetadata(abTests, moreHeaders) {
        // TODO: bring the A/B testing info into the metadata.
        var copied = false;
        var metadata = baseMetadata;

        if (moreHeaders) {
          var _loop2 = function _loop2(key) {
            if (key.toLowerCase() !== 'x-goog-api-client' && moreHeaders.hasOwnProperty(key)) {
              if (!copied) {
                copied = true;
                metadata = metadata.clone();
              }

              var value = moreHeaders[key];

              if (Array.isArray(value)) {
                value.forEach(function (v) {
                  return metadata.add(key, v);
                });
              } else {
                metadata.set(key, "".concat(value));
              }
            }
          };

          for (var key in moreHeaders) {
            _loop2(key);
          }
        }

        return metadata;
      };
    }
    /**
     * A wrapper of {@link constructSettings} function under the gRPC context.
     *
     * Most of parameters are common among constructSettings, please take a look.
     * @param {string} serviceName - The fullly-qualified name of the service.
     * @param {Object} clientConfig - A dictionary of the client config.
     * @param {Object} configOverrides - A dictionary of overriding configs.
     * @param {Object} headers - A dictionary of additional HTTP header name to
     *   its value.
     * @return {Object} A mapping of method names to CallSettings.
     */

  }, {
    key: "constructSettings",
    value: function constructSettings(serviceName, clientConfig, configOverrides, headers) {
      return gax.constructSettings(serviceName, clientConfig, configOverrides, this.grpc.status, {
        metadataBuilder: this.metadataBuilder(headers)
      }, this.promise);
    }
    /**
     * Creates a gRPC stub with current gRPC and auth.
     * @param {function} CreateStub - The constructor function of the stub.
     * @param {Object} options - The optional arguments to customize
     *   gRPC connection. This options will be passed to the constructor of
     *   gRPC client too.
     * @param {string} options.servicePath - The name of the server of the service.
     * @param {number} options.port - The port of the service.
     * @param {grpcTypes.ClientCredentials=} options.sslCreds - The credentials to be used
     *   to set up gRPC connection.
     * @return {Promise} A promse which resolves to a gRPC stub instance.
     */
    // tslint:disable-next-line variable-name

  }, {
    key: "createStub",
    value: function createStub(CreateStub, options) {
      var serviceAddress = options.servicePath + ':' + options.port;
      return this._getCredentials(options).then(function (credentials) {
        var grpcOptions = {};
        Object.keys(options).forEach(function (key) {
          if (key.indexOf('grpc.') === 0) {
            grpcOptions[key] = options[key];
          } else if (key.indexOf('grpc_gcp.') === 0) {
            // This prefix is used to pass additional arguments that aren't
            // options for grpc. Strip the prefix before passing.
            var prefixLength = 'grpc_gcp.'.length;
            grpcOptions[key.substr(prefixLength)] = options[key];
          }
        });
        return new CreateStub(serviceAddress, credentials, grpcOptions);
      });
    }
    /**
     * Creates a 'bytelength' function for a given proto message class.
     *
     * See {@link BundleDescriptor} about the meaning of the return value.
     *
     * @param {function} message - a constructor function that is generated by
     *   protobuf.js. Assumes 'encoder' field in the message.
     * @return {function(Object):number} - a function to compute the byte length
     *   for an object.
     */

  }], [{
    key: "_resolveFile",
    value: function _resolveFile(protoPath, filename) {
      if (fs.existsSync(path.join(protoPath, filename))) {
        return path.join(protoPath, filename);
      } else if (COMMON_PROTO_FILES.indexOf(filename) > -1) {
        return path.join(googleProtoFilesDir, filename);
      }

      throw new Error(filename + ' could not be found in ' + protoPath);
    }
  }, {
    key: "createByteLengthFunction",
    value: function createByteLengthFunction(message) {
      return function getByteLength(obj) {
        return message.encode(obj).finish().length;
      };
    }
  }]);

  return GrpcClient;
}();

exports.GrpcClient = GrpcClient;

var GoogleProtoFilesRoot =
/*#__PURE__*/
function (_protobuf$Root) {
  _inherits(GoogleProtoFilesRoot, _protobuf$Root);

  function GoogleProtoFilesRoot() {
    var _getPrototypeOf2;

    _classCallCheck(this, GoogleProtoFilesRoot);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GoogleProtoFilesRoot)).call.apply(_getPrototypeOf2, [this].concat(args)));
  } // Causes the loading of an included proto to check if it is a common
  // proto. If it is a common proto, use the google-proto-files proto.


  _createClass(GoogleProtoFilesRoot, [{
    key: "resolvePath",
    value: function resolvePath(originPath, includePath) {
      originPath = path.normalize(originPath);
      includePath = path.normalize(includePath); // Fully qualified paths don't need to be resolved.

      if (path.isAbsolute(includePath)) {
        if (!fs.existsSync(includePath)) {
          throw new Error('The include `' + includePath + '` was not found.');
        }

        return includePath;
      }

      if (COMMON_PROTO_FILES.indexOf(includePath) > -1) {
        return path.join(googleProtoFilesDir, includePath);
      }

      return GoogleProtoFilesRoot._findIncludePath(originPath, includePath);
    }
  }], [{
    key: "_findIncludePath",
    value: function _findIncludePath(originPath, includePath) {
      originPath = path.normalize(originPath);
      includePath = path.normalize(includePath);
      var current = originPath;
      var found = fs.existsSync(path.join(current, includePath));

      while (!found && current.length > 0) {
        current = current.substring(0, current.lastIndexOf(path.sep));
        found = fs.existsSync(path.join(current, includePath));
      }

      if (!found) {
        throw new Error('The include `' + includePath + '` was not found.');
      }

      return path.join(current, includePath);
    }
  }]);

  return GoogleProtoFilesRoot;
}(protobuf.Root);

exports.GoogleProtoFilesRoot = GoogleProtoFilesRoot;